export const Colors = {
  PrimaryMain: "#01579B",
  PrimaryDark: "#00569C",
  SecondaryLight: "#F5F8FB",
  SecondaryMain: "#6D7278",
  Text: "#252525",
  Red: "#E02020",
  Yellow: "#F7B500",
  Blue: "#71C2FF",
  Body: "#f9f9fb",
  Border: "#D7D7D7",
  BorderDark: "#979797",
  GoogleBtnBorder: "#F0F0F0",
  White: "#fff",
};
